export default __webpack_public_path__ + "static/media/element_spec_97.97f99bdb.webp";